const state = {
    activeSection: undefined,
    availableSections: [],
    resource: undefined,
    sampleData: [],
};
export const Details = {
    namespaced: true,
    state,
};
